import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import DsraEventListModalUI from './DsraEventListModalUI.js'

class DsraEventListModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            submitted: false,
            status: null,
            eventDate: '',
            dsraTotal: '',
            dsraCurrent: '',
            eventDateError: null,
            dsraTotalError: null,
            dsraCurrentError: null
        }
    }

    render() {
        return (
            <DsraEventListModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                updateMode={this.props.updateMode}
                submitted={this.state.submitted}
                status={this.state.status}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.onCancelClick}
                // form fields
                eventDate={this.state.eventDate}
                onEventDateChange={(eventDate) => { this.setState({ eventDate: eventDate }) }}
                eventDateError={this.state.eventDateError}
                setEventDateError={(error) => { this.setState({ eventDateError: error }) }}
                //
                dsraTotal={this.state.dsraTotal}
                onDsraTotalChange={(event) => { this.setState({ dsraTotal: event.target.value }) }}
                dsraTotalError={this.state.dsraTotalError}
                setDsraTotalError={(error) => { this.setState({ dsraTotalError: error }) }}
                //
                dsraCurrent={this.state.dsraCurrent}
                onDsraCurrentChange={(event) => { this.setState({ dsraCurrent: event.target.value }) }}
                dsraCurrentError={this.state.dsraCurrentError}
                setDsraCurrentError={(error) => { this.setState({ dsraCurrentError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        let submitted = this.state.submitted
        if (submitted)
            return
        
        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.post(this.props.context,
            `/api/su/accounts/${this.props.loan.accountId}/dates/${this.state.eventDate}/dsraEvents`,
            this.onSubmitCallback, {
            dsraTotalF: this.state.dsraTotal,
            dsraCurrentF: this.state.dsraCurrent
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null,
                    eventDate: '',
                    dsraTotal: '',
                    dsraCurrent: '',
                })
                this.props.onCancelClick()
                this.props.onRefreshClick()
            }, 1000)
        }
    }

    onCancelClick = () => {
        this.setState({
            errorList: null,
            submitted: false,
        })
        this.props.onCancelClick()
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default DsraEventListModalSF
